import { getCookie } from './cookiesHelper'

export const CONSENT_COOKIE_KEY = 'cookie_consent'
export const ANALYTICS_FIELD = 'analytics_performance'
export const COOKIE_CONSENT_CHANGED_EVENT = 'cookieConsentChanged'

export function getDeviceConsentKey() {
  const deviceId =
    typeof window !== 'undefined' && localStorage.getItem('deviceId')
  return deviceId ? `cookie_consent_${deviceId}` : null
}

export function getSavedPreferences() {
  const deviceKey = getDeviceConsentKey()
  if (deviceKey) {
    const stored = localStorage.getItem(deviceKey)
    if (stored) {
      try {
        return JSON.parse(stored)
      } catch {
        /* ignore */
      }
    }
  }

  const saved = getCookie(CONSENT_COOKIE_KEY)
  if (!saved) return null

  if (typeof saved === 'object') return saved

  try {
    return JSON.parse(saved)
  } catch {
    return null
  }
}
